// extracted by mini-css-extract-plugin
export default {"avatarWrapper":"ProjectUserPopoverBox_avatarWrapper__DeWCp","linkWrapper":"ProjectUserPopoverBox_linkWrapper__tPi8+","avatarLink":"ProjectUserPopoverBox_avatarLink__F2WV1"};